import { jsx } from "react/jsx-runtime";
import React from "react";
import { DataTable, withSelectedEntities } from "@teselagen/ui";
class Mismatches extends React.Component {
  UNSAFE_componentWillMount() {
    const { alignmentData, mismatches } = this.props;
    const mismatchList = this.getMismatchList(alignmentData, mismatches);
    const schema = {
      fields: [{ path: "mismatches", type: "number" }]
    };
    this.setState({ mismatchList, schema });
  }
  getGapMap = (sequence) => {
    const gapMap = [0];
    sequence.split("").forEach((char) => {
      if (char === "-") {
        gapMap[Math.max(0, gapMap.length - 1)] = (gapMap[Math.max(0, gapMap.length - 1)] || 0) + 1;
      } else {
        gapMap.push(gapMap[gapMap.length - 1] || 0);
      }
    });
    return gapMap;
  };
  getMismatchList = (alignmentData, mismatches) => {
    const mismatchList = [];
    let getGaps = () => ({
      gapsBefore: 0,
      gapsInside: 0
    });
    const gapMap = this.getGapMap(alignmentData.sequence);
    getGaps = (rangeOrCaretPosition) => {
      if (typeof rangeOrCaretPosition !== "object") {
        return {
          gapsBefore: gapMap[Math.min(rangeOrCaretPosition, gapMap.length - 1)]
        };
      }
      const { start, end } = rangeOrCaretPosition;
      const toReturn = {
        gapsBefore: gapMap[start],
        gapsInside: gapMap[Math.min(end, gapMap.length - 1)] - gapMap[Math.min(start, gapMap.length - 1)]
      };
      return toReturn;
    };
    const gapsBeforeSequence = getGaps(0).gapsBefore;
    for (let mismatchI = 0; mismatchI < mismatches.length; mismatchI++) {
      const mismatchEnd = mismatches[mismatchI].end;
      const mismatchStart = mismatches[mismatchI].start;
      const mismatchDifference = mismatchEnd - mismatchStart;
      if (mismatchDifference === 0) {
        mismatchList.push({
          mismatches: mismatchStart + 1 - gapsBeforeSequence,
          start: mismatchStart - gapsBeforeSequence,
          end: mismatchStart - gapsBeforeSequence
        });
      } else {
        for (let innerI = 0; innerI <= mismatchDifference; innerI++) {
          mismatchList.push({
            mismatches: mismatchStart + innerI + 1 - gapsBeforeSequence,
            start: mismatchStart + innerI - gapsBeforeSequence,
            end: mismatchStart + innerI - gapsBeforeSequence
          });
        }
      }
    }
    return mismatchList;
  };
  render() {
    const { mismatchList, schema } = this.state;
    let tableOfMismatches;
    if (mismatchList.length === 0) {
      tableOfMismatches = null;
    } else {
      tableOfMismatches = /* @__PURE__ */ jsx(
        DataTable,
        {
          maxHeight: 168,
          formName: "mismatchesTable",
          isSimple: true,
          compact: true,
          noRouter: true,
          schema,
          entities: mismatchList
        }
      );
    }
    return /* @__PURE__ */ jsx("div", { style: { maxHeight: 180.8, overflowY: "scroll" }, children: /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          // margin: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        },
        children: /* @__PURE__ */ jsx("div", { style: { width: 100, margin: 4 }, children: tableOfMismatches })
      }
    ) });
  }
}
export default withSelectedEntities("mismatchesTable")(Mismatches);
